import * as React from "react";

// Import styles
import "./styles/contactForm.scss";

// Bootstrap imports
import { Col, Container, Row } from "react-bootstrap";

const ContactForm = (props) => {
  return (
    <Container>
      <h2 className="shout fade-in-slow">Contact Us</h2>
      <div className="contact-form fade-in-slow">
        <form
          id="contact"
          name="Contact Form"
          method="POST"
          data-netlify="true"
          action="/thank-you"
        >
          <input type="hidden" name="form-name" value="Contact Form" />
          <Row>
            <Col xs={12} md={6}>
              <label>
                Name
                <input type="text" name="Name" placeHolder="Enter your name." />
              </label>
              <label>
                Email
                <input
                  type="email"
                  name="Email"
                  placeHolder="Enter your email."
                />
              </label>
              <label>
                What is your estimated budget for this project?
                <select name="budget" id="budget">
                  <option value="$6,000-$12,000">$6,000-$12,000</option>
                  <option value="$12,000-$25,000">$12,000-$25,000</option>
                  <option value="$25,000-$75,000">$25,000-$75,000</option>
                  <option value="$75,000-$150,000">$75,000-$150,000</option>
                  <option value="$150,000-$250,000">$150,000-$250,000</option>
                  <option value="$250,000+">$250,000+</option>
                  <option value="I’m not sure">I’m not sure</option>
                </select>
              </label>
            </Col>
            <Col xs={12} md={6}>
              <label>
                Message
                <textarea
                  name="Message"
                  placeHolder="Type us a message."
                ></textarea>
              </label>
            </Col>
            <Col xs={12}>
              <button className="btn btn-accent" type="submit">
                Submit
              </button>
            </Col>
          </Row>
        </form>
      </div>
    </Container>
  );
};

export default ContactForm;
